import { View } from '@react-pdf/renderer';
import React from "react";

const PDFLoader: React.FC<{}> = () => {
    return (<>
        <View render={() => (<>
            <View style={{ fontFamily: 'Poppins', fontWeight: 100 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 200 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 300 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 400 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 500 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 600 }} />
            <View style={{ fontFamily: 'Poppins', fontWeight: 700 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 100 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 200 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 300 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 400 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 500 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 600 }} />
            <View style={{ fontFamily: 'Inter', fontWeight: 700 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 100 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 200 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 300 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 400 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 500 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 600 }} />
            <View style={{ fontFamily: 'Lato', fontWeight: 700 }} />
        </>)} />
    </>);
}

export default PDFLoader;